import { z } from "zod";

import { providerIntegrationProviderSchema } from "./providerIdentity";

export const providerIntegrationOperationResourceTypeSchema = z.enum([
  "task",
  "project",
  "folder",
  "comment",
  "attachment",
  "subtask",
  "custom_field",
  "status",
]);

export const providerIntegrationOperationActionSchema = z.enum([
  "create",
  "update",
  "delete",
  "comment",
  "attach",
  "link",
  "complete",
]);

export const providerIntegrationOperationStatusSchema = z.enum([
  "requested",
  "pending",
  "running",
  "succeeded",
  "failed_retryable",
  "failed_terminal",
  "needs_reconciliation",
  "cancelled",
]);

export type ProviderIntegrationOperationStatus = z.infer<
  typeof providerIntegrationOperationStatusSchema
>;

export type ProviderIntegrationOperationResourceType = z.infer<
  typeof providerIntegrationOperationResourceTypeSchema
>;

export type ProviderIntegrationOperationAction = z.infer<
  typeof providerIntegrationOperationActionSchema
>;

export const providerIntegrationOperationActorSchema = z
  .object({
    type: z.string(),
  })
  .passthrough();

export const providerIntegrationOperationSourceSchema = z
  .object({
    type: z.string(),
  })
  .passthrough();

export const providerIntegrationOperationSchema = z.object({
  enterpriseId: z.string(),
  provider: providerIntegrationProviderSchema,
  resourceType: providerIntegrationOperationResourceTypeSchema,
  action: providerIntegrationOperationActionSchema,
  status: providerIntegrationOperationStatusSchema,
  idempotencyKey: z.string(),
  requestHash: z.string(),
  requestPayload: z.record(z.unknown()),
  externalResourceId: z.string().optional(),
  externalUrl: z.string().optional(),
  requestedBy: providerIntegrationOperationActorSchema,
  executedBy: providerIntegrationOperationActorSchema,
  source: providerIntegrationOperationSourceSchema,
  attempts: z.number().optional(),
  leaseOwner: z.string().optional(),
  leaseExpiresAt: z.date().nullable().optional(),
  lastError: z
    .object({
      message: z.string(),
      code: z.string().optional(),
      timestamp: z.date(),
    })
    .optional(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type ProviderIntegrationOperation = z.infer<
  typeof providerIntegrationOperationSchema
>;
